import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import scopus from '../assets/img/scopus.png';
import thomson from '../assets/img/thomsonReuters.png';
import google from '../assets/img/googleScholar.png';
import sinta from '../assets/img/garuda.png';
import { useNavigate } from 'react-router-dom';
import HeaderLogin from './main/nav-login/HeaderLogin';
import Footer from './main/nav/Footer';

function PublicationLink({ href, src, alt, className = 'h-7' }) {
    if (!href) {
        return null;
    }

    return (
        <a href={href} target="_blank" rel="noreferrer" className="inline-flex rounded-md p-1 transition hover:bg-slate-100">
            <img src={src} alt={alt} className={`${className} w-auto object-contain`} />
        </a>
    );
}

export default function Repository() {
    const navigate = useNavigate();
    const [searchVal, setSearchVal] = useState('');
    const [tabel, setTabel] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const gotoGrafik = () => {
        navigate('/');
    };

    const fetchData = async () => {
        const { data } = await axios.get('/data-get');
        if (data) {
            setData(data);
        }
    };

    const fetchRepo = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get('repo');
            if (data) {
                setTabel(data);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        fetchRepo();
    }, []);

    const filteredRows = useMemo(() => {
        const keyword = searchVal.trim().toLowerCase();
        if (!keyword) {
            return tabel;
        }

        return tabel.filter((row) => JSON.stringify(row).toLowerCase().includes(keyword));
    }, [searchVal, tabel]);

    return (
        <div className="min-h-screen bg-slate-50 text-brand-navy">
            <HeaderLogin data={data} grafik={gotoGrafik} />

            <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
                <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                    <div>
                        <span className="text-xs font-extrabold uppercase tracking-normal text-brand-green">Repository</span>
                        <h1 className="mt-2 font-display text-3xl font-extrabold">Daftar Author dan ID Publikasi</h1>
                    </div>
                    <label className="w-full sm:max-w-sm">
                        <span className="sr-only">Cari repository</span>
                        <input
                            value={searchVal}
                            onChange={(event) => setSearchVal(event.target.value)}
                            placeholder="Cari author, fakultas, atau publikasi..."
                            className="h-11 w-full rounded-lg border border-slate-200 bg-white px-4 text-sm font-semibold outline-none transition focus:border-brand-green focus:ring-2 focus:ring-brand-green/20"
                        />
                    </label>
                </div>

                <section className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-soft">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
                            <thead className="bg-brand-soft text-xs font-extrabold uppercase tracking-normal text-slate-600">
                                <tr>
                                    <th className="w-16 px-4 py-4">No</th>
                                    <th className="min-w-72 px-4 py-4">Author/Bidang Keahlian</th>
                                    <th className="min-w-40 px-4 py-4">Fakultas</th>
                                    <th className="min-w-56 px-4 py-4">ID Publikasi</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="px-4 py-10 text-center text-sm font-semibold text-slate-500">
                                            Memuat data repository...
                                        </td>
                                    </tr>
                                ) : null}

                                {!loading && filteredRows.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="px-4 py-10 text-center text-sm font-semibold text-slate-500">
                                            Data tidak ditemukan.
                                        </td>
                                    </tr>
                                ) : null}

                                {!loading && filteredRows.map((row, index) => (
                                    <tr key={`${row?.user?.id || 'repo'}-${index}`} className="align-top transition hover:bg-slate-50">
                                        <td className="px-4 py-4 font-bold text-slate-500">{index + 1}.</td>
                                        <td className="px-4 py-4">
                                            <a href={`https://fsd.unsam.ac.id/${row?.user?.alias}`} target="_blank" rel="noreferrer" className="font-extrabold text-brand-navy no-underline hover:text-brand-green">
                                                {row?.user?.nama}., {row?.gelar_depan}, {row?.gelar_belakang}
                                            </a>
                                            <p className="mt-2 text-sm italic leading-6 text-slate-500">{row?.user?.profile?.fokus || '-'}</p>
                                        </td>
                                        <td className="px-4 py-4 text-base font-semibold text-slate-700">{row?.fakultas || '-'}</td>
                                        <td className="px-4 py-4">
                                            <div className="flex flex-wrap items-center gap-2">
                                                <PublicationLink href={row?.user?.profile?.scopus} src={scopus} alt="Scopus" />
                                                <PublicationLink href={row?.user?.profile?.thomson} src={thomson} alt="Thomson Reuters" className="h-6" />
                                                <PublicationLink href={row?.user?.profile?.google} src={google} alt="Google Scholar" />
                                                <PublicationLink href={row?.user?.profile?.sinta} src={sinta} alt="Sinta" className="h-6" />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </main>

            <div className="bg-brand-navy text-white">
                <Footer />
            </div>
        </div>
    );
}
